import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
    image: {
        width: 95,
        height: 40,
        marginRight: 16,
        borderRadius: 5,
    },
    opacity: {
        opacity: 0.5,
    },
    beforeYouDepositSheet: { maxHeight: 400 },
});
